<template>
	<div>
		<v-card-title>
			<h2>Lista ofert</h2>
		</v-card-title>
		<BidderOfferList/>
	</div>
</template>

<script>
	import BidderOfferList from "./components/BidderOfferList";

	export default {
		name: "BidderOfferView",
		components: {BidderOfferList},
	};
</script>

<style scoped>

</style>
